export function getCartPaymentMethodFromSavedCards({ cart, savedCards }) {
    return savedCards.find(
        (savedCard) =>
            savedCard.token === cart.payment_session.data.paymentMethodToken
    );
}
